import { Component } from '@angular/core';

@Component({
  selector: 'app-redemptionpoint',
  templateUrl: './redemptionpoint.component.html'
})
export class RedemptionpointComponent {
}
